/* KOMTO (BAN-179, coordinator's final phone walk, items 16d/e/k): the Shopify Inbox chat button on phones.
 * - It hides while the page scrolls down and comes back on a scroll up or near the top (body.komto-chat-away).
 * - It hides while an add-to-basket button (the main one or the sticky bar's) passes under it
 *   (body.komto-buy-under-chat), measured against the chat button's real place on the screen.
 * The open chat window is never hidden. Styles: main.css («chat button on phones»).
 */
(() => {
  const phone = window.matchMedia('(max-width: 749px)');
  const body = document.body;
  let lastY = window.scrollY;
  let raf = 0;

  const chatRect = () => {
    const chat = document.querySelector('shopify-chat');
    const button = chat && chat.shadowRoot && chat.shadowRoot.querySelector('[part~="activator"]');
    return button ? button.getBoundingClientRect() : null;
  };

  const check = () => {
    raf = 0;
    const y = window.scrollY;
    if (!phone.matches) {
      body.classList.remove('komto-chat-away', 'komto-buy-under-chat');
      lastY = y;
      return;
    }
    if (y < 200 || y < lastY - 8) body.classList.remove('komto-chat-away');
    else if (y > lastY + 8) body.classList.add('komto-chat-away');
    if (Math.abs(y - lastY) > 8 || y < 200) lastY = y;

    const chat = chatRect();
    let under = false;
    if (chat && chat.width) {
      document.querySelectorAll('[name="add"], .sticky-atc-panel button[type="submit"]').forEach((buy) => {
        const r = buy.getBoundingClientRect();
        if (!r.width || !r.height) return;
        if (r.right > chat.left - 8 && r.left < chat.right + 8 && r.bottom > chat.top - 8 && r.top < chat.bottom + 8) under = true;
      });
    }
    body.classList.toggle('komto-buy-under-chat', under);
  };

  const queue = () => {
    if (!raf) raf = requestAnimationFrame(check);
  };
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  // the chat button appears a moment after load; the sticky bar slides in on scroll
  setTimeout(queue, 1500);
  setTimeout(queue, 4000);
  queue();
})();
